var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIconOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7075 10.0001L13.8534 6.85405C14.0489 6.65876 14.0489 6.34189 13.8534 6.14659C13.658 5.95114 13.3414 5.95114 13.146 6.14659L10.0001 9.29263L6.85402 6.14659C6.65856 5.95114 6.34204 5.95114 6.14659 6.14659C5.95114 6.34189 5.95114 6.65876 6.14659 6.85405L9.29266 10.0001L6.14659 13.1461C5.95114 13.3414 5.95114 13.6583 6.14659 13.8536C6.24431 13.9511 6.37239 14 6.5003 14C6.62821 14 6.75629 13.9511 6.85402 13.8534L10.0001 10.7074L13.146 13.8534C13.2437 13.9511 13.3718 14 13.4997 14C13.6276 14 13.7557 13.9511 13.8534 13.8534C14.0489 13.6581 14.0489 13.3412 13.8534 13.1459L10.7075 10.0001Z",
    fill: "#252730",
    stroke: "#252730"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconOutline);
export default __webpack_public_path__ + "static/media/CloseIconOutline.a8da1d3febe327a3221acfb071bff97f.svg";
export { ForwardRef as ReactComponent };